// In your JavaScript code
import 'autotrack/lib/plugins/page-visibility-tracker';
import 'autotrack/lib/plugins/social-widget-tracker';
import 'autotrack/lib/plugins/url-change-tracker';
import 'autotrack/lib/plugins/media-query-tracker';
import 'autotrack/lib/plugins/event-tracker';

import { GA_ID, siteTrackerName } from './constants';

export default ({ media } = {}) => {
    const { ga } = window;

    ga('create', GA_ID.main, 'auto');

    const trackers = [''];
    const keys = Object.keys(GA_ID);

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];

        if (key !== 'main' && window.location.hostname.indexOf(key) > -1) {
            ga('create', GA_ID[key], 'auto', siteTrackerName);
            trackers.push(`${siteTrackerName}.`);
            break;
        }
    }

    trackers.forEach(name => {
        if (process.env.NODE_ENV === 'development') {
            // prevent any hits from being sent to Google Analytics
            ga(`${name}set`, 'sendHitTask', null);
        }

        ga(`${name}require`, 'urlChangeTracker', { fieldsObj: { dimension1: 'virtual (urlChangeTracker)' } });
        ga(`${name}require`, 'socialWidgetTracker');
        ga(`${name}require`, 'eventTracker');
        // ga(`${name}require`, 'pageVisibilityTracker');
        ga(`${name}require`, 'mediaQueryTracker', {
            definitions: [
                {
                    name: 'Breakpoint',
                    dimensionIndex: 2,
                    items: Object.keys(media).map(viewport => ({
                        name: viewport,
                        media: media[viewport],
                    })),
                },
            ],
        });

        ga(`${name}set`, 'anonymizeIp', true);
        ga(`${name}set`, 'appName', 'React Client');
        ga(`${name}set`, 'appVersion', '2.0');
        ga(`${name}send`, 'pageview', { dimension1: 'initial page load' });
    });
};
